import { motion } from 'motion/react';
import React, { MouseEventHandler, useState } from 'react'

interface Props
{
    children?: string;
    onClick: MouseEventHandler<Element>;
    className?: string;
    duration?: number;
}

const SpringButton = ({children = "", onClick, className = "", duration = 0.2}: Props) => {
    const [clicked, setClicked] = useState(false);

    className = "button " + className;


    return (
        <motion.button 
            className={className}
            whileHover={{scale: 1.15, backgroundColor: 'var(--ubackground2)', color: '#FFFFFF'}}
            whileTap={{scale: 1, backgroundColor: 'var(--ubackground2)', color: '#FFFFFF'}}
            onClick={onClick}
        >
        {children}
        </motion.button>
    );
}

export default SpringButton
